"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawSurfaceIcon = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("@emotion/react");
const DrawSurfaceIcon = (_a) => {
    var { color } = _a, props = __rest(_a, ["color"]);
    const theme = (0, react_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ width: "32", height: "32", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M23.5228 3.50963C23.0021 2.98894 22.1579 2.98894 21.6372 3.50963L5.40677 19.7401L2.92693 27.2085L2.66675 27.9999C2.66675 28.7363 3.2637 29.3333 4.00008 29.3333L28.0001 29.3333C28.7365 29.3333 29.3334 28.7363 29.3334 27.9999C29.3334 27.2635 28.7365 26.6666 28.0001 26.6666H11.1129L12.0064 26.3397L28.2369 10.1093C28.7576 9.5886 28.7576 8.74438 28.2369 8.22368L23.5228 3.50963ZM22.319 6.59907L25.1474 9.42749L11.1942 23.3807L6.55996 25.1866L8.36573 20.5524L22.319 6.59907Z", fill: color !== null && color !== void 0 ? color : theme.colors.white }) })));
};
exports.DrawSurfaceIcon = DrawSurfaceIcon;
//# sourceMappingURL=draw_surface_icon.js.map